import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Article from "@/pages/article/page";
import PillarArticle from "@/pages/pillar/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/usfans-spreadsheet-guide",
    element: <Article />,
  },
  {
    path: "/articles/:slug",
    element: <PillarArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;